<template>
  <aha-icon
    name="arrow-tail"
    class="onboarding__arrow"
    :class="{
      'in-template-library': isInTemplateLibraty
    }"
    width="23"
    height="24"
    viewBox="0 0 18 19"
    @click="backToOnboardingV3()"
    v-if="hasOnboardingV3"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
    }),
    isInTemplateLibraty() {
      return this.$route.name === 'TemplateLibrary'
    },
  },
  methods: {
    ...mapActions(['setIsOnboardingV3ShowingAction']),
    backToOnboardingV3() {
      this.setIsOnboardingV3ShowingAction(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.onboarding__arrow {
  @apply absolute top-10 -left-4 cursor-pointer;
  &.in-template-library {
    @apply top-18 left-5;
  }
}
</style>
